export enum DeviceCategory {
  Television = 'Television',
  Tablet = 'Tablet',
  Laptop = 'Laptop',
  MobilePhone = 'Mobile Phone',
  GamesConsoles = 'Games Consoles',
}

export enum DeviceDetailsField {
  Type = 'deviceType',
  Brand = 'brand',
  PurchaseDate = 'purchaseDate',
  PurchasePrice = 'purchasePrice',
}

export interface CategoryFormValue {
  category: string;
}

export interface DeviceCategoryType {
  name: string;
  code: string;
}

export interface DeviceCategoryTypesRecord {
  [key: string]: DeviceCategoryType[];
}

export interface PurchaseDate {
  month: number;
  year: number;
}

export interface DeviceFormValue {
  deviceType: string;
  brand: string;
  purchaseDate: PurchaseDate;
  purchasePrice: string;
  brandName?: string;
  phoneModel?: string;
  imei?: string;
  lt?: boolean;
}
